import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { 
  User, 
  Settings, 
  LogOut, 
  Bell,
  Camera
} from "lucide-react";
import { toast } from "sonner";
import { getImageUrl } from "../lib/utils";

export default function MemberMenu({ member, onLogout, onUpdateAvatar }) {
  const navigate = useNavigate();

  const getInitials = () => {
    if (!member?.name) return "?";
    return member.name.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2);
  };

  const handleLogout = () => {
    localStorage.removeItem("tireo_member_token");
    localStorage.removeItem("tireo_member");
    toast.success("Déconnexion réussie");
    if (onLogout) onLogout();
    navigate("/");
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="relative h-9 w-9 sm:h-10 sm:w-10 rounded-full p-0">
          <Avatar className="h-9 w-9 sm:h-10 sm:w-10 border-2 border-amber-500">
            <AvatarImage src={getImageUrl(member?.avatar_url)} alt={member?.name} />
            <AvatarFallback className="bg-gradient-to-br from-amber-500 to-orange-600 text-white text-sm font-medium">
              {getInitials()}
            </AvatarFallback>
          </Avatar>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56" align="end" forceMount>
        <DropdownMenuLabel className="font-normal">
          <div className="flex flex-col space-y-1">
            <p className="text-sm font-medium leading-none">{member?.name}</p>
            <p className="text-xs leading-none text-muted-foreground">{member?.email}</p>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        
        <DropdownMenuItem asChild>
          <Link to="/play/profile" className="cursor-pointer">
            <User className="mr-2 h-4 w-4" />
            Mon profil
          </Link>
        </DropdownMenuItem>
        
        <DropdownMenuItem asChild>
          <Link to="/play/subscriptions" className="cursor-pointer">
            <Bell className="mr-2 h-4 w-4" />
            Mes abonnements
          </Link>
        </DropdownMenuItem>
        
        {onUpdateAvatar && (
          <DropdownMenuItem onClick={onUpdateAvatar} className="cursor-pointer">
            <Camera className="mr-2 h-4 w-4" />
            Changer ma photo
          </DropdownMenuItem>
        )}
        
        <DropdownMenuSeparator />
        
        <DropdownMenuItem onClick={handleLogout} className="cursor-pointer text-red-600">
          <LogOut className="mr-2 h-4 w-4" />
          Déconnexion
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
